import { EDeductionType } from "../../deductions";
import { schemes, zSchema } from "../../schema-validation";
import { EDisbursementMethod } from "../../workers-shared";
import { EEmployeeCheckStatus } from "../IEmployeeCheck";

export const employeeCheckSchema = zSchema.object({
  approval_required: zSchema.boolean(),
  approved: zSchema.boolean(),
  check_date: schemes.isoDate(),
  companyID: schemes.uuid(),
  deductions: zSchema
    .array(
      zSchema
        .object({
          archived: zSchema.boolean(),
          company_id: schemes.uuid(),
          deduction_credit: zSchema.boolean(),
          deduction_schema_version: zSchema.literal("2.0.0"),
          deduction_template_name: zSchema.string(),
          deduction_template_id: schemes.mongoOrUuid(),
          deduction_type: zSchema.nativeEnum(EDeductionType),
          employee_calculated_contribution: zSchema.number(),
          employer_calculated_contribution: zSchema.number(),
          employee_check_id: schemes.uuid(),
          employee_contribution: zSchema
            .object({
              contribution_type: zSchema.enum(["dollars", "percentage"]),
              value: zSchema.number(),
            })
            .optional(),
          employer_contribution: zSchema
            .object({
              contribution_type: zSchema.enum(["dollars", "percentage"]),
              value: zSchema.number(),
            })
            .optional(),
        })
        .optional()
    )
    .optional(),
  disbursement: zSchema.object({
    method: zSchema.nativeEnum(EDisbursementMethod),
    link: zSchema.string().optional(),
  }),
  employeeID: schemes.mongoObjectId(),
  employerCheckID: schemes.mongoObjectId().optional(),
  first_name: zSchema.string(),
  flsa_ot_recommendation: zSchema.boolean(),
  gross_pay: zSchema.number(),
  last_name: zSchema.string(),
  net_pay: zSchema.number(),
  paystub_id: schemes.uuid(),
  paystub_snapshot_out_of_sync: zSchema.boolean().optional(),
  reportingPeriodID: schemes.mongoObjectId(),
  status: zSchema.nativeEnum(EEmployeeCheckStatus),
  status_detail: zSchema.string().optional(),
  taxengine_check_id: schemes.mongoObjectId().optional(),
  taxes: zSchema.array(zSchema.any()),
  totals: zSchema.object({
    employee_taxes: zSchema.number(),
    employer_taxes: zSchema.number(),
  }),
});

export type TEmployeeCheckSchema = zSchema.infer<typeof employeeCheckSchema>;
